import { FCC } from "@/types/common";
import { TCompanyForm } from "@/features/company/types/CompanyForm";
import { CompanyTitle } from "@/features/company/components/CompanyTitle";
import { Grid } from "@mui/material";
import { CompanyBasicInfo } from "@/features/company/components/company-detail/CompanyBasicInfo";
import { CompanyContractInfo } from "@/features/company/components/company-detail/CompanyContractInfo";
import { CompanyContactInfo } from "@/features/company/components/company-detail/CompanyContactInfo";
import { CompanyIndustryFieldDetail } from "@/features/company/components/company-detail/CompanyIndustryFieldDetail";
import { useNavigate, useParams } from "react-router-dom";
import { MenuNavigate } from "@/components/elements/MenuNavigate";
import { BusinessOfficeDetail } from "@/features/company/components/company-detail/BusinessOfficeDetail";
import { CompanyBranchDetail } from "@/features/company/components/company-detail/CompanyBranchDetail";
import { CompanyAdditionalDetailInfo } from "@/features/company/components/company-detail/CompanyAdditionalDetailInfo";
import { CompanyJobInfo } from "@/features/company/components/company-detail/CompanyJobInfo";
import { CompanyFooterContainer } from "@/features/company/components/CompanyFooterContainer";
import { Button } from "@/components/elements/Button";
import { AppRoutes } from "@/routes/config";
import { useEffect } from "react";
import { getDynamicRoute } from "@/utils/url";
import { IconEditor } from "@/assets/icons";

type TCompanyDetailProps = {
  defaultValues?: Partial<TCompanyForm>;
};
export const CompanyDetailContent: FCC<TCompanyDetailProps> = ({ defaultValues }) => {
  if (!defaultValues) return;
  const { companyId } = useParams();
  const navigate = useNavigate();
  useEffect(() => {
    if (!companyId) return navigate(AppRoutes.companyList);
  }, [companyId]);

  const editRoute = getDynamicRoute(AppRoutes.companyEdit, { companyId: companyId });

  return (
    <>
      <CompanyTitle
        title={defaultValues.companyName}
        managementNumber={defaultValues.managementNumber}
        isArchive={defaultValues?.isArchive}
        createdAt={defaultValues.createdAt}
        updatedAt={defaultValues.updatedAt}
      />
      <Grid
        container
        sx={{
          marginTop: 4,
        }}
      >
        <Grid item xs={12}>
          <MenuNavigate
            contents={[
              { title: "企業基本情報", content: <CompanyBasicInfo defaultValues={defaultValues} /> },
              { title: "業種・分野", content: <CompanyIndustryFieldDetail defaultValues={defaultValues} /> },
              { title: "営業所情報", content: <BusinessOfficeDetail defaultValues={defaultValues} /> },
              { title: "事業所情報", content: <CompanyBranchDetail defaultValues={defaultValues} /> },
              { title: "担当者情報", content: <CompanyContactInfo defaultValues={defaultValues} /> },
              { title: "その他の情報", content: <CompanyAdditionalDetailInfo defaultValues={defaultValues} /> },
              { title: "基本契約書", content: <CompanyContractInfo defaultValues={defaultValues} /> },
              { title: "求人情報", content: <CompanyJobInfo defaultValues={defaultValues} /> },
            ]}
            contentAffix={
              <CompanyFooterContainer isShowSetArchiveButton={true} isArchive={defaultValues.isArchive}>
                <Button variant="outline" size="sm" onClick={() => navigate(editRoute)} startIcon={<IconEditor />}>
                  編集
                </Button>
              </CompanyFooterContainer>
            }
            contentWidth="900px"
          />
        </Grid>
      </Grid>
    </>
  );
};
